var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { AuthActionTypes } from "./auth.actions";
export var authInitialState = {
    loading: false,
    error: null,
    user: null,
    logged: false,
    loggedOnce: false
};
export function authReducer(state, action) {
    if (state === void 0) { state = authInitialState; }
    switch (action.type) {
        case AuthActionTypes.LoginAction:
        case AuthActionTypes.SignupAction:
            return __assign({}, state, { loading: true });
        case AuthActionTypes.LogoutAction:
        case AuthActionTypes.NullToken:
            return __assign({}, state, { loading: false, error: null, user: null, logged: false });
        case AuthActionTypes.LoggedOnce:
            return __assign({}, state, { loggedOnce: action.payload });
        case AuthActionTypes.AuthTokenPayload:
        case AuthActionTypes.TokenRestore:
            return __assign({}, state, { error: null, loading: false, user: action.payload, logged: true });
        case AuthActionTypes.AuthFailure:
            return __assign({}, state, { error: action.payload, loading: false, user: null, logged: false });
        default:
            return state;
    }
}
